/* A495 - the water filter offered beside Add to Cart on a Blizzard page.
   Data comes from Liquid in layout/theme.liquid (window.RB_A495); this file
   only decides where the box goes and what the button does. */
(function () {
  var d = window.RB_A495;
  if (!d || !d.id) return;                       /* not a page we speak for */

  /* ☠️☠️ IMMEDIATELY AFTER THE FORM, NEVER INSIDE IT.
     Measured on the live CE preview, 21-08-2026. A307's price converter skips
     anything matching `form[action*="/cart"]` -- deliberately, because a cart
     is always the amount actually charged and must stay inc-GST. Mounted next
     to the Add to Cart button INSIDE that form, this box inherited the same
     exemption: the page read $2,013.65 EX GST while our filter read $269.50
     wearing an "EX GST" label it had not been converted for. A shelf price
     labelled ex-GST that is really inc-GST is the exact Leggatt St complaint
     A350 exists to prevent -- and a label makes it worse, not better.
     Outside the form it is an ordinary shelf price and follows the switch.
     ★ Visually this is the same place: the form ends just below the buttons. */
  var tries = 0;
  function mount() {
    if (document.querySelector('[data-a495]')) return;    /* never twice */
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form && form.parentNode) {
      form.insertAdjacentElement('afterend', box());
      return;
    }
    /* No buy form at all means nothing to add alongside -- give the theme a
       moment in case it renders the form late, then leave the page alone. */
    if (++tries < 40) setTimeout(mount, 50);
  }

  function box() {
    var wrap = document.createElement('div');
    wrap.className = 'a495-filter';
    wrap.setAttribute('data-a495', '');

    var head = document.createElement('p');
    head.className = 'a495-filter__head';
    head.textContent = 'This ice maker does not include a water filter';
    wrap.appendChild(head);

    var why = document.createElement('p');
    why.className = 'a495-filter__why';
    why.textContent = 'A filter is required to keep the warranty valid, and '
      + 'it is what gives you clear, hard ice that melts slowly. The cartridge '
      + 'is replaced every 6 months.';
    wrap.appendChild(why);

    var row = document.createElement('div');
    row.className = 'a495-filter__row';

    if (d.img) {
      var img = document.createElement('img');
      img.className = 'a495-filter__img';
      img.src = d.img;
      img.alt = d.title || 'Water filter';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      row.appendChild(img);
    }

    var meta = document.createElement('div');
    meta.className = 'a495-filter__meta';

    var name = document.createElement('a');
    name.className = 'a495-filter__name';
    name.href = d.url;
    name.textContent = d.title;
    meta.appendChild(name);

    var price = document.createElement('span');
    price.className = 'a495-filter__price';
    /* .money is what A307's converter looks for: this number then follows the
       page's ex/inc GST switch instead of contradicting it. */
    var amount = document.createElement('span');
    amount.className = 'money';
    amount.textContent = d.price;
    price.appendChild(amount);
    var tag = document.createElement('span');
    tag.className = 'a495-filter__tag';
    tag.setAttribute('data-gst-label', '');
    price.appendChild(document.createTextNode(' '));
    price.appendChild(tag);
    meta.appendChild(price);
    row.appendChild(meta);

    var btn = document.createElement('button');
    /* ☠️ The box sits inside the product form. Without this the click submits
       the form and adds the ICE MAKER. */
    btn.type = 'button';
    btn.className = 'a495-filter__btn';
    btn.textContent = 'Add filter';
    row.appendChild(btn);

    var said = document.createElement('p');
    said.className = 'a495-filter__said';
    said.setAttribute('role', 'status');
    said.setAttribute('aria-live', 'polite');

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: d.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function () {
        btn.textContent = 'Filter added';
        said.innerHTML = '';
        said.appendChild(document.createTextNode('Added to your cart. '));
        var a = document.createElement('a');
        a.href = '/cart';
        a.textContent = 'View cart';
        said.appendChild(a);
        /* Let the theme's own cart count refresh if it listens. */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add filter';
        said.textContent = 'Sorry, that did not go through. '
          + 'You can add the filter from its own page.';
      });
    });

    wrap.appendChild(row);
    wrap.appendChild(said);
    return wrap;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
